// iOS fullscreen owns an exit gesture that conflicts with score scrubbing.
// Include iPadOS's desktop identity, even when a trackpad makes its pointer fine.
export function useCustomFullscreen({userAgent='',platform='',maxTouchPoints=0} = globalThis.navigator || {}) {
  return /iPad|iPhone|iPod/.test(userAgent) ||
    (platform==='MacIntel'||/Macintosh/.test(userAgent)) && maxTouchPoints>1;
}
